export enum BackendTools {
  ExecuteQuery = 'execute_query',
  LdsGeocode = 'lds_geocode',
  AsyncWorkflowJobGetResults = 'async_workflow_job_get_results',
  GenerateChart = 'generate_chart',
  GetSemanticModel = 'get_semantic_model'
}

// Server tools any assistant can mount. Kept out of BackendTools: the Builder AI Agent offers and labels every member of that enum.
export enum AssistantBackendTools {
  ReadGuide = 'read_guide'
}

export enum BuilderAssistantTools {
  UpdateMap = 'update_map',
  UpdateMapDataset = 'update_map_dataset',
  PublishMap = 'publish_map',
  CreateNamedVersion = 'create_named_version',
  GetMap = 'get_map',
  ListMapDatasets = 'list_map_datasets',
  Describe = 'describe',
  ListConnections = 'list_connections',
  ListResources = 'list_resources',
  SearchResources = 'search_resources',
  ListMaps = 'list_maps',
  GetMapSchema = 'get_map_schema',
  GetWorkspaceInfo = 'get_workspace_info',
  ListMapAgentModels = 'list_map_agent_models',
  GetMapAgentsStatus = 'get_map_agents_status',
  ListWorkflowMcpTools = 'list_workflow_mcp_tools'
}
